// Update this configuration file based on your project information
export const AppConfig = {
  name: 'Era',
  locales: ['en'],
  defaultLocale: 'en',
  localePrefix: 'as-needed',
};
